var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNotificationEmptyMobile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "82px",
    height: "97px",
    viewBox: "0 0 82 97",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icNotificationEmptyMobile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "empty-state-notification",
    transform: "translate(-147.000000, -197.000000)",
    fill: "#666666"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.531049,279.5 C145.156317,279.5 145.156317,268.350877 152.531049,268.350877 C158.501071,268.350877 158.852248,246.77193 158.852248,239.219298 C158.852248,221.236842 169.38758,210.807018 181.327623,208.289474 C179.220557,203.254386 182.732334,197.5 188,197.5 C193.267666,197.5 196.779443,203.254386 194.672377,208.289474 C206.61242,210.807018 217.147752,221.236842 217.147752,239.219298 C217.147752,246.77193 217.498929,268.350877 223.468951,268.350877 C230.843683,268.350877 230.843683,279.5 223.468951,279.5 L152.531049,279.5 Z M193.985515,282.5 C196.867966,287.3125 193.264902,293.5 187.5,293.5 C181.735098,293.5 178.132034,287.3125 181.014485,282.5 L193.985515,282.5 Z",
    id: "icNotificationEmptyMobile"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotificationEmptyMobile);
export default __webpack_public_path__ + "static/media/icNotificationEmptyMobile.01990ded5d80ee513c5cfd1b9a40ec0b.svg";
export { ForwardRef as ReactComponent };